/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Evidence_Vendor_Claim_DescInputs */

const en_directory_evidence_vendor_claim_desc = /** @type {(inputs: Directory_Evidence_Vendor_Claim_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stated by the vendor; not independently verified.`)
};

const zh_directory_evidence_vendor_claim_desc = /** @type {(inputs: Directory_Evidence_Vendor_Claim_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来自厂商自述，未经独立核实。`)
};

/**
* | output |
* | --- |
* | "Stated by the vendor; not independently verified." |
*
* @param {Directory_Evidence_Vendor_Claim_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_evidence_vendor_claim_desc = /** @type {((inputs?: Directory_Evidence_Vendor_Claim_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Evidence_Vendor_Claim_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_evidence_vendor_claim_desc(inputs)
	return zh_directory_evidence_vendor_claim_desc(inputs)
});
export { directory_evidence_vendor_claim_desc as "directory.evidence.vendor_claim_desc" }